// extracted by mini-css-extract-plugin
module.exports = {"containerAsFooter":"Links_containerAsFooter__2I-iJ","container":"Links_container__3Rvpw"};